import { createTheme } from '@mui/material'

export const calendarTheme = createTheme({
  palette: {
    primary: {
      main: '#141414',
    },
  },
})
